import {NgModule} from '@angular/core';
import {MatMomentDateModule, MomentDateAdapter} from '@angular/material-moment-adapter';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatChipsModule} from '@angular/material/chips';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MAT_RIPPLE_GLOBAL_OPTIONS} from '@angular/material/core';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatDialogModule} from '@angular/material/dialog';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatListModule} from '@angular/material/list';
import {MatMenuModule} from '@angular/material/menu';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatSelectModule} from '@angular/material/select';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatSortModule} from '@angular/material/sort';
import {MatStepperModule} from '@angular/material/stepper';
import {MatTableModule} from '@angular/material/table';
import {MatTabsModule} from '@angular/material/tabs';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatTreeModule} from '@angular/material/tree';
import {DatetimeAdapter, MAT_DATETIME_FORMATS, MatDatetimepickerModule} from '@mat-datetimepicker/core';
import {MEXOS_MAT_MOMENT_DATE_FORMATS, MEXOS_MAT_MOMENT_DATE_TIME_FORMATS} from '../consts/date-time-format-consts';
import {MomentDatetimeAdapter} from '../utils/moment-date-time-adapter';

@NgModule({
    providers: [
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MEXOS_MAT_MOMENT_DATE_FORMATS},
        { provide: MAT_DATETIME_FORMATS, useValue: MEXOS_MAT_MOMENT_DATE_TIME_FORMATS },
        MomentDateAdapter,
        { provide: DatetimeAdapter, useClass: MomentDatetimeAdapter },
        { provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: {
                disabled: true,
                animation: {
                    enterDuration: 300,
                    exitDuration: 0
                }
            }
        }
    ],
    imports: [
        MatTableModule,
        MatInputModule,
        MatSelectModule,
        MatDatepickerModule,
        MatDatetimepickerModule,
        MatMomentDateModule,
        MatExpansionModule,
        MatButtonModule,
        MatToolbarModule,
        MatDialogModule,
        MatSnackBarModule,
        MatTabsModule,
        MatTooltipModule,
        MatFormFieldModule,
        MatCheckboxModule,
        MatPaginatorModule,
        MatSortModule,
        MatProgressBarModule,
        MatStepperModule,
        MatIconModule,
        MatCardModule,
        MatChipsModule,
        MatGridListModule,
        MatButtonModule,
        MatSidenavModule,
        MatMenuModule,
        MatListModule,
        MatProgressSpinnerModule,
        MatTreeModule
    ],
    exports: [
        MatTableModule,
        MatInputModule,
        MatSelectModule,
        MatDatepickerModule,
        MatMomentDateModule,
        MatDatetimepickerModule,
        MatExpansionModule,
        MatButtonModule,
        MatToolbarModule,
        MatDialogModule,
        MatSnackBarModule,
        MatTabsModule,
        MatTooltipModule,
        MatFormFieldModule,
        MatCheckboxModule,
        MatPaginatorModule,
        MatSortModule,
        MatProgressBarModule,
        MatStepperModule,
        MatIconModule,
        MatCardModule,
        MatGridListModule,
        MatChipsModule,
        MatSidenavModule,
        MatMenuModule,
        MatListModule,
        MatProgressSpinnerModule,
        MatTreeModule
    ]
})

export class MxMaterialModule {
}
